import { ToggleSwitch } from '@features/operations/components/ToggleSwitch'
import { sectionCardClasses } from 'shared-ui/components'
import { useDebug } from 'shared-ui/debug'
import { useLocalization } from 'shared-ui/localization'

export const AdminSettings: React.FC = () => {
  const { t } = useLocalization()
  const { isDebugMode, setIsDebugMode } = useDebug()

  return (
    <div className="flex flex-col gap-8">
      <div className={sectionCardClasses()}>
        <h2 className="mb-4 text-center text-gray-500">{t(($) => $.titles.debugMode)}</h2>
        <div className="flex w-full items-center justify-between">
          <span>When on, debug mode enables logging to the browser console</span>
          <span>
            <ToggleSwitch checked={isDebugMode} onChange={() => setIsDebugMode(!isDebugMode)} />{' '}
            {isDebugMode ? 'On' : 'Off'}
          </span>
        </div>
      </div>
    </div>
  )
}
